var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26687(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26687",
    "data-name": "Group 26687",
    transform: "translate(-148 -880)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(148 880)",
    fill: "#e03093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23261",
    "data-name": "Path 23261",
    d: "M953.163,73.73h1.172v28.14h-1.172a3.607,3.607,0,0,1-3.517-3.517v-21.1a3.607,3.607,0,0,1,3.517-3.517m24.622,0h2.345v28.14H956.681V73.73h2.345V70.212a3.607,3.607,0,0,1,3.517-3.517h11.725a3.607,3.607,0,0,1,3.517,3.517ZM975.44,86.041a.588.588,0,0,0-.586-.586h-4.1v-4.1a.588.588,0,0,0-.586-.586h-3.517a.588.588,0,0,0-.586.586v4.1h-4.1a.588.588,0,0,0-.586.586v3.517a.588.588,0,0,0,.586.586h4.1v4.1a.588.588,0,0,0,.586.586h3.517a.59.59,0,0,0,.586-.586v-4.1h4.1a.588.588,0,0,0,.586-.586Zm-12.9-12.311h11.725V70.212H962.543Zm24.622,3.517v21.1a3.608,3.608,0,0,1-3.517,3.517h-1.172V73.73h1.172a3.606,3.606,0,0,1,3.517,3.517",
    transform: "translate(-784.646 831.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26687);
export default __webpack_public_path__ + "static/media/Group 26687.7fa37e139acf14e12b45904e4d016c2a.svg";
export { ForwardRef as ReactComponent };